var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsWordiginsImportBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a86b18;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M108.818,135.591c8.151-4.714,15.582-18.89,16.86-38.219l-16.86-.011Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.359,135.591V97.361H80.5C81.777,116.7,89.208,130.876,97.359,135.591Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M108.818,47.683v38.23h16.86C124.4,66.572,116.969,52.4,108.818,47.683Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.5,85.913h16.86V47.683C89.208,52.4,81.776,66.573,80.5,85.913Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128.92,53.847a79.462,79.462,0,0,1,8.194,32.066h11.211a45.691,45.691,0,0,0-19.4-32.066Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.851,97.361a45.72,45.72,0,0,0,19.405,32.066,79.442,79.442,0,0,1-8.194-32.066Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M206.188,143.184V40.09a28.681,28.681,0,0,0-28.641-28.641H28.63A28.666,28.666,0,0,0,0,40.09V143.184a28.666,28.666,0,0,0,28.63,28.641h40.1v28.63a5.726,5.726,0,0,0,9.161,4.586l44.286-33.216h55.371a28.681,28.681,0,0,0,28.641-28.641Zm-103.094,5.724a57.342,57.342,0,1,1,40.474-16.794,57.3,57.3,0,0,1-40.474,16.794Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128.92,129.427a45.687,45.687,0,0,0,19.405-32.066H137.114a79.458,79.458,0,0,1-8.194,32.066Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.851,85.913H69.062a79.442,79.442,0,0,1,8.194-32.066A45.724,45.724,0,0,0,57.851,85.913Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M223.37,45.814a5.729,5.729,0,1,0,0,11.458,17.206,17.206,0,0,1,17.183,17.183V177.549a17.206,17.206,0,0,1-17.183,17.182H177.547a5.719,5.719,0,0,0-5.724,5.724v22.906L135.16,195.869a5.727,5.727,0,1,0-6.862,9.172l45.823,34.364h-.011a5.726,5.726,0,0,0,9.161-4.585V206.19h40.1A28.666,28.666,0,0,0,252,177.549V74.455a28.666,28.666,0,0,0-28.63-28.641Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWordiginsImportBrown);
export default __webpack_public_path__ + "static/media/icons_wordigins_import_brown.2fcf8531bc8a6f24a28bc9b5d24c6a48.svg";
export { ForwardRef as ReactComponent };